module.exports = __webpack_public_path__ + "media/max-clear.ea812424.wav";